import { Button, dialog } from "nq-component";
import React, { Component } from "react";
import CardView from "../../../../components/common/CardView";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import BasePage from "../../../../base/BasePage";
import { ServiceRecordLeave } from "../../../../components/common/Converter";
import FormFactory from "../../../../components/FormFactory";

export default class SeparateEmployee extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      dateSeparation: "",
      cause: "",
      selectedFiles: [],
      id: props.data.id,
    };
  }

  async componentDidMount() {}

  onChangeForm(value, field) {
    this.setState({ [field]: value });
  }

  dialogClose() {
    dialog.close();
  }
  async confirmChanges() {
    if (this.state.submitting) return;

    this.submitting();
    dialog.close();
    const { id } = this.state;
    const { employmentType, ...res } = this.props.data;

    // const employee = await findObjectUseCase().execute("employees", {
    //   where: this.getCurrentUser().employee,
    //   includes: ["position"],
    // });

    const resignedData = {
      type: this.state.type,
      dateSeparation: this.state.dateSeparation,
      cause: this.state.cause,
      employee: { id: res.id },
      selectedFiles: this.state.selectedFiles,
      id: id,
    };

    const employeeData = {
      id: id,
      seperationType: this.state.type,
    };

    try {
      await upsertUseCase().execute("seperated", resignedData);
      await upsertUseCase().execute("employees", employeeData);
      this.insertServiceRecord(resignedData);
      this.props.closeSeparateEmployee();
      this.showSuccess("Success");
    } catch (e) {
      console.error(e.message || e);
      this.submissionError();
    } finally {
      this.submissionSuccess();
    }
  }

  async insertServiceRecord(updateEmployee) {
    const effectivity = new Date();

    // console.log("service: ", this.props.data);
    const serviceRec = await findObjectUseCase().execute("service_record", {
      where: { empID: this.props?.data?.id, to: { $exists: false } },
    });

    let dateFrom = "";
    if (serviceRec[0]?.from) {
      dateFrom = new Date(serviceRec[0]?.from);
      dateFrom?.setDate(dateFrom?.getDate() - 1);
    }
    const leaveReq = await findObjectUseCase().execute("leave_request", {
      where: {
        employee: { id: updateEmployee.id },
        stats: { $ne: "For Processing" },
        $or: [
          { startdate: { $gte: dateFrom || "", $lte: effectivity } },
          { enddate: { $gte: dateFrom || "", $lte: effectivity } },
        ],
      },
    });

    console.log("TEST: ", leaveReq);
    const serviceLog = {
      email: this.props?.data?.email,
      empID: this.props?.data?.id,
      from: effectivity,
      employee: { id: this.props?.data.id },
      designation: this.props?.data?.position?.position_title,
      status: updateEmployee?.employmentType?.name || "",
      salary: this.props?.data?.salaryGrade,
      station: "BUREAU OF IMMIGRATION",
      branch: "NATIONAL",
      date: updateEmployee?.dateSeparation,
      cause: updateEmployee?.cause,
    };
    console.log("service: ", serviceLog);
    if (serviceRec.length > 0) {
      let leaveStatus = [];
      for (const leave of leaveReq) {
        // Extract and abbreviate the selectedType
        const selectedType = leave.selectedType;
        const abbreviation = selectedType
          .split(" ") // Split the string into an array of words
          .map((word) => word.charAt(0)) // Take the first letter of each word
          .join(""); // Join them back together

        // Format the startDate and endDate
        leaveStatus.push(
          ServiceRecordLeave(
            abbreviation,
            new Date(leave?.startdate),
            new Date(leave?.enddate)
          )
        ); // Add to the result array
      }

      serviceRec[0].to = serviceLog?.from;
      serviceRec[0].leave = leaveStatus;
      serviceRec[0].status = serviceLog?.status;
      // console.log("LEAVE: ", serviceRec);
      await upsertUseCase().execute("service_record", serviceRec[0]);
    }
    console.log("SERVICE: ", serviceLog);
    await upsertUseCase().execute("service_record", serviceLog);
  }

  handleClickOk() {
    if (this.state.submitting) return;

    dialog.fire({
      html: (
        <div>
          <div className="row">
            <div
              className="col-md-12"
              style={{ width: "100%", margin: "0 auto" }}
            >
              <h4 className="mt-2 ms-2">Confirmation</h4>
              <hr />
            </div>
            <p
              className="text-center"
              style={{ fontSize: "13px", padding: "1rem" }}
            >
              Are you sure you want to process Separate Employee?
            </p>
            <div
              className="col-md-12"
              style={{ width: "100%", margin: "0 auto" }}
            >
              <hr />
            </div>
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              progress={this.state.submitting}
              disabled={this.state.submitting}
              onClick={() => {
                if (this.state.submitting) return;
                this.confirmChanges();
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
    // }
  }
  render() {
    const { objects, data } = this.props;
    const isMobile = window.innerWidth <= 768;
    const schema = this.getSchema("seperated");
    return (
      <>
        <>
          <div
            className="w-100 h-100 position-fixed end-0 start-0 overflow-y-auto d-flex justify-content-center align-items-center"
            style={{
              zIndex: 1050,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
            }}
          >
            {/* Existing modal content */}
            <div
              className="w-100 d-flex column align-items-center"
              style={{
                maxHeight: "99%",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: isMobile ? "90%" : "40rem",
                }}
              >
                <CardView style={{ padding: 0 }}>
                  <h4 className="fs-6 fw-bold pt-3 ps-3">Separated Employee</h4>
                  <hr />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      this.handleClickOk();
                    }}
                  >
                    <div className="w-100" style={{ padding: "0 1.5rem" }}>
                      <FormFactory
                        schema={schema}
                        className="mb-2"
                        // object={object}
                        // disabled={true}
                        onChange={this.onChangeForm.bind(this)}
                      />
                    </div>
                    <hr />
                    <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                      <Button
                        className="btn btn-light fs-sm"
                        onClick={() => this.props.closeSeparateEmployee()}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn btn-primary"
                        type="submit"
                        progress={this.state.submitting}
                        disabled={this.state.submitting}
                      >
                        OK
                      </Button>
                    </div>
                  </form>
                </CardView>
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}
